/* eslint-disable no-alert */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import moment from 'moment'

import { Grid, Table, Button, Label, Segment } from 'semantic-ui-react'

import Loading from '../../components/common/loading'

import MerchantSettlementActions from '../../reducers/merchantSettlementReducer'

class MerchantSettlementDetail extends Component {

  componentDidMount() {
    const { loaded, syncMerchantSettlements } = this.props

    if (!loaded) {
      syncMerchantSettlements()
    }
  }

  onPaidMerchant = (merchantSettlement, restaurant, branch) => {
    const { paidMerchant } = this.props
    const confirmed = window.confirm('Are you sure to make this action?')

    if (confirmed) {
      paidMerchant(merchantSettlement, restaurant, branch)
    }
  }

  renderRestaurants = merchantSettlement => {
    const { restaurants } = merchantSettlement

    if (_.size(restaurants) > 0) {
      const branchRows = []
      let i = 0
      _.map(restaurants, restaurant => {
        const branches = _.map(restaurant.branches, branch => {
          i += 1
          const paidDate = branch.paid_at ? moment(Number(branch.paid_at)).format('DD-MMM-YYYY HH:mm a') : ''
          const abaNumber = branch.aba_account_number ? branch.aba_account_number : '--'
          const abaName = branch.aba_account_name ? `${branch.aba_account_name}` : '--'

          return (
            <Table.Row key={branch.key}>
              <Table.Cell>{ i }</Table.Cell>
              <Table.Cell>{ restaurant.name } - { branch.name }</Table.Cell>
              <Table.Cell>
                <div>{abaName}</div>
                <div>{abaNumber}</div>
              </Table.Cell>
              <Table.Cell textAlign="center">{ branch.order_count }</Table.Cell>
              <Table.Cell textAlign="center">$ { Number(parseFloat(branch.total_amount).toFixed(2)) }</Table.Cell>
              <Table.Cell textAlign="center">{ paidDate }</Table.Cell>
              <Table.Cell textAlign="center">
                {
                  branch.status === 'paid' ?
                    <Label color="green">Paid</Label>
                    :
                    <Button size="mini" onClick={ () => this.onPaidMerchant(merchantSettlement, restaurant, branch) }>Pay Now</Button>
                }
              </Table.Cell>
            </Table.Row>
          )
        })
        branchRows.push(branches)
      })

      return branchRows
    }

    return (
      <Table.Row>
        <Table.Cell textAlign="center" colSpan={6}>
          No results
        </Table.Cell>
      </Table.Row>
    )
  }

  render() {
    const { loading, merchantSettlements, match } = this.props
    const merchantSettlementId = match.params.id
    const merchantSettlement = merchantSettlements[merchantSettlementId] || []

    const startAt = moment(Number(merchantSettlement.start_at)).format('DD-MMM-YYYY')
    const endAt = moment(Number(merchantSettlement.end_at)).format('DD-MMM-YYYY')

    return (
      <div>
        <Loading active={loading} />
        <Segment>
          <h5 style={{ textAlign: 'center' }}>{startAt} - {endAt}</h5>
        </Segment>
        <Grid columns="equal">
          <Grid.Column grid={16}>
            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>No</Table.HeaderCell>
                  <Table.HeaderCell>Name</Table.HeaderCell>
                  <Table.HeaderCell>ABA Info</Table.HeaderCell>
                  <Table.HeaderCell textAlign="center">Order Count</Table.HeaderCell>
                  <Table.HeaderCell textAlign="center">Amount</Table.HeaderCell>
                  <Table.HeaderCell textAlign="center">Paid Date</Table.HeaderCell>
                  <Table.HeaderCell textAlign="center">Action</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                { this.renderRestaurants(merchantSettlement) }
              </Table.Body>
            </Table>
          </Grid.Column>
        </Grid>
      </div>
    )
  }
}

const mapState = ({ merchantSettlements }) => ({
  loaded: merchantSettlements.loaded,
  loading: merchantSettlements.loading,
  merchantSettlements: merchantSettlements.data
})

const mapDispatch = {
  syncMerchantSettlements: MerchantSettlementActions.syncMerchantSettlements,
  paidMerchant: MerchantSettlementActions.paidMerchant
}

export default connect(
  mapState,
  mapDispatch
)(MerchantSettlementDetail)


// WEBPACK FOOTER //
// ./src/containers/merchantSettlement/detail.js